(function () {
  function parseQuery(raw) {
    const terms = raw.trim().split(/\s+/);
    const include = [];
    const exclude = [];
    terms.forEach(t => {
      if (t.startsWith('-') && t.length > 1) {
        exclude.push(t.slice(1).toLowerCase());
      } else {
        include.push(t);
      }
    });
    return { include, exclude };
  }

  // フォームsubmit時に除外ワードをsessionStorageに保存
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action="/search"]');
    if (!form) return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const { include, exclude } = parseQuery(input.value);

    if (exclude.length > 0) {
      sessionStorage.setItem('search_exclude', JSON.stringify(exclude));
      input.value = include.join(' ');
    } else {
      sessionStorage.removeItem('search_exclude');
    }
  });

  // 検索結果ページで除外ワードを含むアイテムを非表示
  function applyExclusions() {
    const raw = sessionStorage.getItem('search_exclude');
    if (!raw) return;

    const exclude = JSON.parse(raw);
    // Impulseの検索結果カードセレクタ
    const items = document.querySelectorAll('.search-results .grid__item, .search-results .product-item');
    items.forEach(item => {
      const text = item.textContent.toLowerCase();
      if (exclude.some(word => text.includes(word))) {
        item.style.display = 'none';
      }
    });
  }

  if (window.location.pathname === '/search') {
    applyExclusions();
  }
})();
